import { render, staticRenderFns } from "./SithMesStoolPrApplicationRecordEdit.vue?vue&type=template&id=37c24c4c&"
import script from "./SithMesStoolPrApplicationRecordEdit.vue?vue&type=script&lang=js&"
export * from "./SithMesStoolPrApplicationRecordEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports